"use client";

import React from "react";
import { useRouter } from "next/navigation";

export default function ClearFilterButtons({ fq }) {
  const router = useRouter();

  const clearAllFilters = () => {
    let currentParams =
      window.location.href.split("?").length > 1
        ? window.location.href
            .split("?")[1]
            .replace(/&fq=.*?(?=&|$)/g, "")
            .replace(/fq=.*?(?=&|$)/g, "")
            .replace(/&page=\d+/, "")
            .replace(/page=\d+/, "")
        : "";
    if (currentParams.startsWith("&")) {
      currentParams = currentParams.substring(1);
    }

    router.push("?" + currentParams);
  };

  const handleClearButton = (key, value) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let fq = decodeURIComponent(urlParams.get("fq") || "");

    let currentParams =
      window.location.href.split("?").length > 1
        ? window.location.href
            .split("?")[1]
            .replace(/&fq=.*?(?=&|$)/g, "")
            .replace(/fq=.*?(?=&|$)/g, "")
            .replace(/&page=\d+/, "")
            .replace(/page=\d+/, "")
        : "";
    if (currentParams.startsWith("&")) {
      currentParams = currentParams.substring(1);
    }
    if (fq !== "") {
      fq = fq.replace(`;${key}||${value}`, "").replace(`${key}||${value}`, "");
      if (fq.startsWith(";")) {
        fq = fq.substring(1);
      }
    }

    const params = new URLSearchParams();
    params.set("fq", fq.replace(/&/g, "%26"));

    router.push(
      "?" +
        currentParams +
        (fq !== "" ? (currentParams != "" ? "&" : "") + params.toString() : "")
    );
  };

  return (
    <>
      {fq != "" && (
        <>
          <a
            href="#"
            className="clear-all-facets selected-facet"
            onClick={clearAllFilters}
          >
            Clear all
          </a>
          {fq.split(";").map((filter) => {
            const filterName = filter.split("||")[0];
            const filterValue = decodeURIComponent(filter.split("||")[1]);
            return (
              <a
                key={filter}
                href="#"
                className="selected-facet"
                onClick={() => {
                  handleClearButton(filterName, filterValue);
                }}
              >
                {filterValue}
              </a>
            );
          })}
        </>
      )}
    </>
  );
}
